import playbook from "./playbook";
import clause from "./clause";

import { combineReducers } from "redux";

export default combineReducers({
  playbook,
  clause,
});
